import React, { useState, useEffect } from 'react';
import {
    Box,
    Paper,
    TextField,
    Button,
    Typography,
    Grid,
    Stack,
    Divider,
    Alert
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux'
import { updateBreadcrumb } from '@redux/commonReducer'
import apiService from '@services/common';
import { Save } from '@mui/icons-material';
const UserProfilePage = () => {
    // State cho thông tin user
    const [profile, setProfile] = useState({
        name: '',
        email: '',
    });

    const breadcrumb =
        [
            {
                name: 'Thông tin người dùng',
                url: 'profile'
            }
        ]

    const dispatch = useDispatch()

    // State loading + message
    const [savingProfile, setSavingProfile] = useState(false);
    const [profileMessage, setProfileMessage] = useState(null);
    const [profileError, setProfileError] = useState(null);

    // Giả lập load dữ liệu user khi mở màn (anh thay bằng API thật)
    useEffect(() => {
        dispatch(updateBreadcrumb(breadcrumb))
        const fetchProfile = async () => {
            try {
                // Ví dụ:
                const res = await apiService.get('profile');
                setProfile({
                    name: res.data.data.name,
                    email: res.data.data.email,
                });
            } catch (err) {
                console.error(err);
            }
        };

        fetchProfile();
    }, []);

    // Handle change cho form profile
    const handleProfileChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Validate đơn giản email
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    // Submit cập nhật profile
    const handleSubmitProfile = async (e) => {
        e.preventDefault();
        setProfileError(null);
        setProfileMessage(null);

        if (!profile.name.trim()) {
            setProfileError('Tên không được để trống');
            return;
        }

        if (!profile.email.trim()) {
            setProfileError('Email không được để trống');
            return;
        }

        if (!isValidEmail(profile.email)) {
            setProfileError('Email không hợp lệ');
            return;
        }

        try {
            setSavingProfile(true);

            // Gọi API cập nhật profile ở đây
            const res = await apiService.put('profile', profile);

            // Demo chờ 500ms
            await new Promise((resolve) => setTimeout(resolve, 500));

            setProfileMessage('Cập nhật thông tin thành công');
        } catch (err) {
            console.error(err);
            setProfileError('Có lỗi xảy ra khi cập nhật thông tin');
        } finally {
            setSavingProfile(false);
        }
    };


    return (
        <Box
            sx={{
                width: '100%',
                mx: 'auto',
                mt: 4,
                px: 2,
            }}
        >
            <Typography variant="h5" fontWeight={600} gutterBottom>
                Thông tin tài khoản
            </Typography>

            <Paper sx={{ p: 3, mb: 4 }}>


                {profileError && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {profileError}
                    </Alert>
                )}

                {profileMessage && (
                    <Alert severity="success" sx={{ mb: 2 }}>
                        {profileMessage}
                    </Alert>
                )}

                <Box component="form" noValidate onSubmit={handleSubmitProfile}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                sx={{ minWidth: 300 }}
                                label="Họ và tên"
                                name="name"
                                value={profile.name}
                                onChange={handleProfileChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                sx={{ minWidth: 300 }}
                                label="Email"
                                name="email"
                                type="email"
                                value={profile.email}
                                onChange={handleProfileChange}
                            />
                        </Grid>
                    </Grid>

                    <Stack direction="row" justifyContent="flex-end" mt={3}>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={savingProfile}
                            startIcon={<Save />}
                        >
                            {savingProfile ? 'Đang lưu...' : 'Lưu thay đổi'}
                        </Button>
                    </Stack>
                </Box>
            </Paper>
        </Box>
    );
};

export default UserProfilePage;
